import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SubCategoryList = () => {
  const [SubCategoryUser, setSubCategoryUser] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );

        if (response.data && Array.isArray(response.data.row)) {
          setSubCategoryUser(response.data.row);
        } else {
          setSubCategoryUser([]);
          console.warn("Unexpected API response structure.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSubCategoryUser([]);
        toast.error("Failed to fetch subcategories.");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
      );
      const data = await res.json();

      if (data.success === "1" && Array.isArray(data.row)) {
        const map = {};
        data.row.forEach((category) => {
          map[category.category_id] = category.category_name;
        });
        setCategoryMap(map);
        console.log("Category Map Created:", map);
      }
    } catch (err) {
      console.error("Category fetch failed", err);
    }
  };

  fetchCategories();
}, []);


  const deleteUser = async (subId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_main_subcategory",
        { subcategory_id: subId },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success === "1") {
        setSubCategoryUser((prev) =>
          prev.filter((user) => user.subcategory_id !== subId)
        );
        toast.error("Subcategory deleted successfully!");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete subcategory.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Sub Categories List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Sub Categories</Link>
                </li>
                <li className="breadcrumb-item active">Subcategories List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">All Subcategories List</h4>
                <Link to="/sub-category-add" className="btn btn-sm btn-primary">
                  Add Sub Category
                </Link>
              </div>

              <div className="table-responsive">
                <table className="table align-middle mb-0 table-hover table-centered">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th>#</th>
                      <th>Sub Category</th>
                      <th>Category ID</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Array.isArray(SubCategoryUser) &&
                      SubCategoryUser.map((user, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>

                          {/* Subcategory Image + Name */}
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                <img
                                  src={
                                    user.image
                                      ? `https://cyberathon.com/multivendor/${user.image}`
                                      : "/noimage.png"
                                  }
                                  alt={user.subcategory_name}
                                  className="avatar-md"
                                />
                              </div>

                              <p className="text-dark fw-medium fs-15 mb-0">
                                {user.subcategory_name}
                              </p>
                            </div>
                          </td>

                          <td>{categoryMap[user.category_id] || "Category"}</td>

                          <td>{user.created_at}</td>

                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/sub-category-view/${user.subcategory_id}`}
                                className="btn btn-light btn-sm"
                              >
                                <i className="fa-solid fa-eye fs-18"></i>
                              </Link>

                              <Link
                                to={`/sub-category-edit/${user.subcategory_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-18"></i>
                              </Link>

                              <button
                                className="btn btn-soft-danger btn-sm"
                                onClick={() => deleteUser(user.subcategory_id)}
                              >
                                <i className="fa-solid fa-trash fs-18"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}

                    {SubCategoryUser.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center text-muted">
                          No Sub categories Found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                    <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
                  </ul>
                </nav>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid text-center">
          © Venton. Crafted with ♥ by Techzaa
        </div>
      </footer>
    </div>
  );
};

export default SubCategoryList;
